export function copy(data) {
  return JSON.parse(JSON.stringify(data));
}
import * as mymath from "mathjs";
import { apiPost } from "@/api/api";

//除
export function etmsDivide(a, b) {
  return mymath.divide(a, b).toFixed(2);
}

//乘
export function etmsMultiply(a, b) {
  return mymath.multiply(a, b).toFixed(2);
}

//加
export function etmsAdd(a, b) {
  return mymath.add(a, b).toFixed(2);
}

//减
export function etmsSubtract(a, b) {
  return mymath.subtract(a, b).toFixed(2);
}

export function etmsToFixed2(a) {
  return parseFloat(a).toFixed(2);
}

export function etmsGetDecimalDefault(s) {
  if (s && typeof s == "string") {
    s = s.trim();
  }
  if (!s || s === "") {
    return "0";
  } else {
    return s;
  }
}

export function GetClassSetTimeDesc(startTimeDesc, endTimeDesc) {
  return `${startTimeDesc} - ${endTimeDesc}`;
}

export function GetNowFormatDate() {
  let date = new Date();
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let strDate = date
    .getDate()
    .toString()
    .padStart(2, "0");
    if (
      navigator.userAgent.includes("iPhone") ||
      navigator.userAgent.includes("iPad") 
    ) {
      console.log("ios")
      return `${date.getFullYear()}/${month}/${strDate} `;
    } else {
      return `${date.getFullYear()}-${month}-${strDate} `;
    }
}

export function GetFormatDate(date) {
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let strDate = date
    .getDate()
    .toString()
    .padStart(2, "0");
  if (
    navigator.userAgent.includes("iPhone") ||
    navigator.userAgent.includes("iPad") 
  ) {
    return `${date.getFullYear()}/${month}/${strDate}`;
  } else {
    return `${date.getFullYear()}-${month}-${strDate}`;
  }
}
export function GetFormatYearMonth(val) {
  let date;
  if (val) {
    date = val;
  } else {
    date = new Date();
  }
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  return `${date.getFullYear()}-${month}`;
}
export function GetRecentDays(moment, subtractDays) {
  let date = [];
  let start = moment()
    .subtract(subtractDays, "days")
    .format("YYYY-MM-DD");
  let end = moment().format("YYYY-MM-DD");
  date.push(start);
  date.push(end);
  return date;
}

export function GetFormaYearMonth(date) {
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let obj = {
    year: date.getFullYear(),
    month: month
  };
  return obj;
}
export function getDatetime(a) {
  //获取时间并格式化字符串
  if (a) {
    var d = new Date(a);
  } else {
    var d = new Date();
  }
  var year = d.getFullYear();
  var month = change(d.getMonth() + 1);
  var day = change(d.getDate());
  var hour = change(d.getHours());
  var minute = change(d.getMinutes());
  function change(t) {
    if (t < 10) {
      return "0" + t;
    } else {
      return t;
    }
  }
  var time = year + "-" + month + "-" + day;
  return time;
}
export function GetThisYear(moment) {
  return moment().format("YYYY");
}

export function GetYearStartEndDate(moment, year) {
  let startTime = moment(`${year}/1/1`);
  var mystartTime = startTime.format("YYYY-MM-DD");
  var endTime = startTime.add(1, "years").add(-1, "days");
  var myendTime = endTime.format("YYYY-MM-DD");
  let date = [];
  date.push(mystartTime);
  date.push(myendTime);
  return date;
}
export function GetThisMonth(moment) {
  return moment().format("YYYY-MM");
}

export function GetMonthStartEndDate(moment, year, month) {
  let startTime = moment(`${year}/${month}/1`);
  var mystartTime = startTime.format("YYYY-MM-DD");
  var endTime = startTime.add(1, "months").add(-1, "days");
  var myendTime = endTime.format("YYYY-MM-DD");
  let date = [];
  date.push(mystartTime);
  date.push(myendTime);
  return date;
}
export function GetMonthStartEndDateThisMonth(moment) {
  let date = moment();
  let year = date.year();
  let month = date.month() + 1;
  return GetMonthStartEndDate(moment, year, month);
}
/**
 * 设置全局缓存
 * @param {key} key
 * @param {加密信息} data
 * @param {非必选,过期时间,单位为分钟} expired
 */
export function setLocal(key, data, expired) {
  if (window.localStorage) {
    let param = {
      data: data,
      expired: new Date().getTime() + expired * 1000 * 60 || null
    };
    localStorage.setItem(key, JSON.stringify(param));
  }
}
/**
 * 获取全局缓存
 * @param {获取全局key} key
 */
export function getLocal(key) {
  if (window.localStorage) {
    let param = localStorage.getItem(key);
    if (param) {
      param = JSON.parse(param);
      if (param.expired && param.expired <= new Date().getTime()) {
        localStorage.removeItem(key);
        return null;
      } else {
        return param.data;
      }
    } else {
      return null;
    }
  }
}
/**
 *移除全局缓存
 * @param {缓存key} key
 */
export function removeLocal(key) {
  if (window.localStorage) {
    localStorage.removeItem(key);
  }
}
const userKey = "userInfoLs";

export async function refreshPermission() {
  return new Promise((resolve, reject) => {
    apiPost("/user/loginInfoH5", {})
      .then(res => {
        removeLocal(userKey);
        
        setLocal(userKey, res.resultData, 10);
        resolve(res.resultData);
      })
      .catch(error => {
        console.log(error);
        reject(error);
      });
  });
}
/*
检验操作权限
*/
export async function checkAction(myActions) {
  let actionObj = getLocal(userKey);
  let userInfo;
  if (actionObj) {
    userInfo = actionObj;
  } else {
    userInfo = await refreshPermission();
  }
  for (var key in myActions) {
    if (userInfo.permission.action.indexOf(parseInt(key)) != -1) {
      myActions[key] = true;
    }
  }
  let obj = {
    myActions,
    userInfo
  };
  return obj;
}
export async function checkPage(myPage) {
  let pageObj = getLocal(userKey);
  let userInfo;
  if (pageObj) {
    userInfo = pageObj;
  } else {
    userInfo = await refreshPermission();
  }
  for (var key in myPage) {
    if (userInfo.permission.page.indexOf(parseInt(key)) != -1) {
      myPage[key] = true;
    }
  }
  let obj = {
    userInfo,
    myPage
  };
  return obj;
}

/**
 * 获取所有可用的操作权限
 * @returns {number[]}
 */
export async function getAllHasActionPermission() {
  let userInfo = getLocal(userKey);
  if (!userInfo) {
    userInfo = await refreshPermission();
  }

  return userInfo.permission.action;
}

/**
 * 获取所有可用的页面权限
 * @returns {number[]}
 */
export async function getAllHasPagePermission() {
  let userInfo = getLocal(userKey);
  if (!userInfo) {
    userInfo = await refreshPermission();
  }

  return userInfo.permission.page;
}

/**
 * 是否有操作权限
 * @param  {...number} names 需要检查的权限
 * @returns {boolean} 是否有此权限
 */
export async function hasActionPermission(...names) {
  let pageObj = getLocal(userKey);
  let userInfo;
  if (pageObj) {
    userInfo = pageObj;
  } else {
    userInfo = await refreshPermission();
  }

  return names.every(v => userInfo.permission.action.includes(v));
}

/**
 * 是否有页面权限
 * @param  {...number} names 需要检查的权限
 * @returns {boolean} 是否有此权限
 */
export async function hasPagePermission(...names) {
  let pageObj = getLocal(userKey);
  let userInfo;
  if (pageObj) {
    userInfo = pageObj;
  } else {
    userInfo = await refreshPermission();
  }

  return names.every(v => userInfo.permission.page.includes(v));
}

export function openUrl(url) {
  var a = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("style", "display:none");
  a.setAttribute("target", "_blank");
  document.body.appendChild(a);
  a.click();
  a.parentNode.removeChild(a);
}

var webOfficeFile =
  "、doc、docx、txt、dot、wps、wpt、dotx、docm、dotm、rtf、ppt、pptx、pptm、ppsx、ppsm、pps、potx、potm、dpt、dps、et、xls、xlt、xlsx、xlsm、xltx、xltm、csv、pdf、";
export function openUrlFile(url, watermark) {
  var index = url.lastIndexOf(".");
  var ext = url.substr(index + 1);
  if (webOfficeFile.indexOf(`、${ext}、`) == -1) {
    openUrlFile2(url, watermark);
    return;
  }
  url = encodeURIComponent(url);
  if (watermark) {
    var tempWatermark = encodeURIComponent(watermark);
    var myurl = `https://pxb.yunvip123.com/#/officeWeb?src=${url}&watermark=${tempWatermark}`;
    openUrl2(myurl);
  } else {
    var myurl = `https://pxb.yunvip123.com/#/officeWeb?src=${url}`;
    openUrl2(myurl);
  }
}

export function openUrlFile2(url, watermark) {
  url = encodeURIComponent(url);
  if (watermark) {
    var tempWatermark = encodeURIComponent(watermark);
    var myurl = `https://view.xdocin.com/view?src=${url}&watermark=${tempWatermark}`;
    openUrl2(myurl);
  } else {
    var myurl = `https://view.xdocin.com/view?src=${url}`;
    openUrl2(myurl);
  }
}

export function openUrl2(url) {
  var a = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("style", "display:none");
  document.body.appendChild(a);
  a.click();
  a.parentNode.removeChild(a);
}

export function defaultActionPermission() {
  return {
    "1": false,
    "2": false,
    "3": false,
    "4": false,
    "5": false,
    "6": false,
    "7": false,
    "8": false,
    "9": false,
    "10": false,
    "11": false,
    "12": false,
    "13": false,
    "14": false,
    "15": false,
    "16": false,
    "17": false,
    "18": false,
    "19": false,
    "20": false,
    "21": false,
    "22": false,
    "23": false,
    "24": false,
    "25": false,
    "26": false,
    "27": false,
    "28": false,
    "29": false,
    "30": false,
    "31": false,
    "32": false,
    "33": false,
    "34": false,
    "35": false,
    "36": false,
    "37": false,
    "38": false,
    "39": false,
    "40": false,
    "41": false,
    "42": false,
    "43": false,
    "44": false,
    "45": false,
    "46": false,
    "47": false,
    "48": false,
    "49": false,
    "50": false,
    "51": false,
    "52": false,
    "53": false,
    "54": false,
    "55": false,
    "56": false,
    "57": false,
    "58": false,
    "59": false,
    "60": false,
    "61": false,
    "62": false,
    "63": false,
    "64": false,
    "65": false,
    "66": false,
    "67": false,
    "68": false,
    "69": false,
    "70": false,
    "71": false,
    "72": false,
    "73": false,
    "74": false,
    "75": false,
    "76": false,
    "77": false,
    "78": false,
    "79": false,
    "80": false,
    "81": false,
    "82": false,
    "83": false,
    "84": false,
    "85": false,
    "86": false,
    "87": false,
    "88": false,
    "89": false,
    "90": false,
    "91": false,
    "92": false,
    "93": false,
    "94": false,
    "95": false,
    "96": false,
    "97": false,
    "98": false,
    "99": false,
    "100": false,
    "101": false,
    "102": false,
    "103": false,
    "104": false,
    "105": false,
    "106": false,
    "107": false,
    "108": false,
    "109": false,
    "110": false,
    "111": false,
    "112": false,
    "113": false,
    "114": false,
    "115": false,
    "116": false,
    "117": false,
    "118": false,
    "119": false,
    "120": false,
    "121": false,
    "122": false,
    "123": false,
    "124": false,
    "125": false,
    "126": false,
    "127": false,
    "128": false,
    "129": false,
    "130": false,
    "131": false,
    "132": false,
    "133": false,
    "134": false,
    "135": false,
    "136": false,
    "137": false,
    "138": false,
    "139": false,
    "140": false
  };
}
export function defaultPagePermission() {
  return {
    "1": false,
    "2": false,
    "3": false,
    "4": false,
    "5": false,
    "6": false,
    "7": false,
    "8": false,
    "9": false,
    "10": false,
    "11": false,
    "12": false,
    "13": false,
    "14": false,
    "15": false,
    "16": false,
    "17": false,
    "18": false,
    "19": false,
    "20": false,
    "21": false,
    "22": false,
    "23": false,
    "24": false,
    "25": false,
    "26": false,
    "27": false,
    "28": false,
    "29": false,
    "30": false,
    "31": false,
    "32": false,
    "33": false,
    "34": false,
    "35": false,
    "36": false,
    "37": false,
    "38": false,
    "39": false,
    "40": false,
    "41": false,
    "42": false,
    "43": false,
    "44": false,
    "45": false,
    "46": false,
    "47": false,
    "48": false,
    "49": false,
    "50": false,
    "51": false,
    "52": false,
    "53": false,
    "54": false,
    "55": false,
    "56": false,
    "57": false,
    "58": false,
    "59": false,
    "60": false,
    "61": false,
    "62": false,
    "63": false,
    "64": false,
    "65": false,
    "66": false,
    "67": false,
    "68": false,
    "69": false,
    "70": false,
    "71": false,
    "72": false,
    "73": false,
    "74": false,
    "75": false,
    "76": false,
    "77": false,
    "78": false,
    "79": false,
    "80": false,
    "81": false,
    "82": false,
    "83": false,
    "84": false,
    "85": false,
    "86": false,
    "87": false,
    "88": false,
    "89": false,
    "90": false,
    "91": false,
    "92": false,
    "93": false,
    "94": false,
    "95": false,
    "96": false,
    "97": false,
    "98": false,
    "99": false,
    "100": false,
    "101": false,
    "102": false,
    "103": false,
    "104": false,
    "105": false,
    "106": false,
    "107": false,
    "108": false,
    "109": false,
    "110": false,
    "111": false,
    "112": false,
    "113": false,
    "114": false,
    "115": false,
    "116": false,
    "117": false,
    "118": false,
    "119": false,
    "120": false,
    "121": false,
    "122": false,
    "123": false,
    "124": false,
    "125": false,
    "126": false,
    "127": false,
    "128": false,
    "129": false,
    "130": false,
    "131": false,
    "132": false,
    "133": false,
    "134": false,
    "135": false,
    "136": false,
    "137": false,
    "138": false,
    "139": false,
    "140": false,
    "141": false,
    "142": false,
    "143": false,
    "144": false,
    "145": false,
    "146": false,
    "147": false,
    "148": false,
    "149": false,
    "150": false
  };
}

export function getYearList() {
  //获取到从那一年开始
  let yearsData = [];
  let smallYears = 2010;
  //获取当前时间
  var date = new Date();
  let nowYears = date.getFullYear();
  var Years = nowYears - smallYears;
  var arrYear = [];
  for (var i = 0; i <= Years; i++) {
    arrYear.push(nowYears--);
  }
  arrYear.forEach(v => {
    //下拉框的数组
    yearsData.push({
      value: v,
      text: v + "年"
    });
  });
  return yearsData;
}

export function isFullPhone(phone) {
  if (!phone || phone === "") {
    return false;
  }
  return phone.indexOf("**") === -1;
}

/** 获取操作权限列表 */
export function getActionPermissionList() {
  return checkAction(defaultActionPermission()).then(res => {
    return res.myActions;
  });
}

/*
dom滚动到底部
*/
export function scrollToBottom(domId) {
  const element = document.getElementById(domId);
  console.log(element, 456);
  if (element) {
    setTimeout(() => {
      element.scrollTop = element.scrollHeight;
    }, 0);
  } else {
    console.error(`Element with id "${domId}" not found.`);
  }
}

export function GetWeekDate(moment, addWeek) {
  let date = [];
  let start = moment()
    .week(moment().week() + addWeek)
    .startOf("week")
    .format("YYYY-MM-DD");
  let end = moment()
    .week(moment().week() + addWeek)
    .endOf("week")
    .format("YYYY-MM-DD");
  date.push(start);
  date.push(end);
  return date;
}



// WEBPACK FOOTER //
// ./src/utils/com.js